export const processTranslations = (translations, intl) => {
    return (translations && translations.find((t) => t.language === intl.locale)) || {title: null, content: null, language: null}
}

export const query = graphql`
  fragment Translation on ContentfulTranslation {
    title
    content {
      raw
    }
    language
  }
`
